import * as React from 'react';

export interface Member {
    id: number;
    name: string | null;
    email: string | null;
    phone: string | null;
}

export type MemberContext = {
    member: Member | null;
    setMember: (member: Member | null) => void;
};

export const MemberContext = React.createContext<MemberContext>({
    member: null,
    setMember: () => {},
});
